import {get, post} from "@/config/api"
const state = {
  orderGood: {},
  cartGoods: [],
};

const getters = {
  orderGood: state => {
    return state.orderGood
  },

  cartGoods: state => {
    return state.cartGoods
  }
};

const mutations = {
  SetOrderGood(state, payload) {
    state.orderGood = payload;
  },
  AddCartGood(state, payload) {
    let has = false
    for (let i = 0; i < state.cartGoods.length; i ++) {
      if (state.cartGoods[i].goodId === payload.goodId && state.cartGoods[i].skuCombId === payload.skuCombId) {
        state.cartGoods[i].Cartcount += payload.Cartcount
        has = true
      }
    }
    if (!has) {
      state.cartGoods.push(payload)
    }
  },
  DelCartGood(state, payload) {
    let result = []
    for (let i = 0; i < state.cartGoods.length; i ++) {
      console.log(payload.delIds, payload.delIds.includes(state.cartGoods[i].skuCombId))
      if (payload.delIds.includes(state.cartGoods[i].skuCombId)) {
        continue
      }
      result.push(state.cartGoods[i])
    }
    state.cartGoods = result
  }

};

const actions = {
  CreateOrderCredit({}, params) {
    return new Promise((resolve, reject) => {
      post("v2/order/create_credit/", params).then((data) => {
        resolve(data)
      }, (err)=> {
        reject(err)
      })
    })
  },

  CreateOrderGoods({}, params) {
    return new Promise((resolve, reject) => {
      post("v2/order/create_goods/", params).then((data) => {
        resolve(data)
      }, (err)=> {
        reject(err)
      })
    })
  },

  PayOrder({}, params) {
    return new Promise((resolve, reject) => {
      post("order/pay/", params).then((data) => {
        resolve(data)
      }, (err)=> {
        reject(err)
      })
    })
  },

  GetOrderGoodList({}, params) {
    return new Promise((resolve, reject) => {
      get("v2/order/good/list/", params).then((data) => {
        resolve(data)
      }, (err)=> {
        reject(err)
      })
    })
  },

  GetShipStatus({}, params) {
    return new Promise((resolve, reject) => {
      get("order/ship_status/", params).then((data) => {
        resolve(data)
      }, (err)=> {
        reject(err)
      })
    })
  },

  GetCreditMenu({}, params) {
    return new Promise((resolve, reject) => {
      get("order/credit/menu/", params).then((data) => {
        resolve(data)
      }, (err)=> {
        reject(err)
      })
    })
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
};
